import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";
import { iconButtonClasses } from "@mui/material/IconButton";
import { svgIconClasses } from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";

export const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`& .${autocompleteClasses.popupIndicator}, & .${autocompleteClasses.clearIndicator}`]: {
    [`& .${svgIconClasses.root}`]: {
      fontSize: "16px",
      color: "inherit",
    },

    [`&.${iconButtonClasses.disabled}`]: {
      color: theme.palette.grey[60],
    },
  },
})) as typeof Autocomplete;
